import GenerateFilters from './GenerateFilters';

export default GenerateFilters;
